
























import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {PostOfficeStore} from "@/modules/postoffices/store";
import debounce from "lodash/debounce";
import {PostOfficeParams} from "@/modules/postoffices/params";

@Component({
    name: "PostOfficeSearch",
    components: {EnumSelector}
})
export default class extends Vue {
    CommonStatus = CommonStatus;
    form = new PostOfficeParams();

    @Watch('form', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        PostOfficeStore.updatePostOfficeParams(val);
        PostOfficeStore.listPostOffice({ ...val, page: 1 })
    }, 500);
}
